const Currency = {
    BritishPound: {
        symbol: '£',
        isoCode: 'GBP',
    },
    Euro: {
        symbol: '€',
        isoCode: 'EUR',
    },
    UnitedStatesDollar: {
        symbol: '$',
        isoCode: 'USD',
    },
    SouthAfricanRand: {
        symbol: 'R',
        isoCode: 'ZAR',
    },
    PolishZloty: {
        symbol: 'PLN',
        isoCode: 'PLN',
    },
};
export default Currency;
//# sourceMappingURL=Currency.js.map